"use strict";

exports.__esModule = true;
exports.DashboardRoutes = DashboardRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _DashboardCollection = require("../DashboardCollection");
var _UpdateDashboardScreen = require("../UpdateDashboardScreen/UpdateDashboardScreen");
var _DashboardScreen = require("../DashboardScreen");
var _DashboardListScreen = require("../DashboardListScreen");
var _CreateDashboardScreen = require("../CreateDashboardScreen");
var _System = require("../../../System");
var _CheckAccessRoute = require("../../Core/CheckAccessRoute/CheckAccessRoute");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _DashboardTagContext = require("../DashboardTagContext");
var _EnhancedContextLoader = require("../../Core/EnhancedContextLoader");
var _AdvancedTimeline = require("../../Timeline/AdvancedTimeline");
var _ManualEventsContext = require("../../Operator/ManualEventsContext");
var _Notifications = require("../../Notifications");
var _DevicePlans = require("../../DevicePlans");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Override global settings for the layout here, see LayoutSettingsController for defaults
var settings = {
  colorSource: {
    realtime: true,
    allowCurrentCycle: true
  },
  backgroundColorSource: {
    realtime: true,
    allowCurrentCycle: true
  },
  dataItemChart: {
    realtime: true
  },
  deviceStatus: {
    enabled: true
  }
};

/**
 * Routes for the dashboard.
 */
function DashboardRoutes(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Provider, settings, /*#__PURE__*/_react["default"].createElement(_Notifications.NotificationSupplier, null, /*#__PURE__*/_react["default"].createElement(_ManualEventsContext.ManualEventSupplier, null, /*#__PURE__*/_react["default"].createElement(_DashboardCollection.DashboardCollectionController, null, /*#__PURE__*/_react["default"].createElement(_EnhancedContextLoader.EnhancedContextLoader, {
    Context: _AdvancedTimeline.AdvancedTimelineContext
  }, /*#__PURE__*/_react["default"].createElement(_DashboardTagContext.DashboardTagContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_DevicePlans.DevicePlansContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("CreateDashboard"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "CREATE_DASHBOARDS",
      component: _CreateDashboardScreen.CreateDashboardScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("UpdateDashboard"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "EDIT_DASHBOARDS",
      component: _UpdateDashboardScreen.UpdateDashboardScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("Dashboard"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_DASHBOARDS",
      component: _DashboardScreen.DashboardScreen
    })
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: (0, _System.getScreenPath)("DashboardList"),
    element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
      permission: "VIEW_DASHBOARDS",
      component: _DashboardListScreen.DashboardListScreen
    })
  })), children)))))));
}